export const scheduleData = [
  {
    key: '1',
    cate: '기존교육원현장방문',
    title: '전화상담',
    actDt: '2020-11-01',
    regDt: '2020-11-01 10:00:00',
  },
  {
    key: '2',
    cate: '기존교육원현장방문',
    title: '전화상담',
    actDt: '2020-11-01',
    regDt: '2020-11-01 10:00:00',
  },
  {
    key: '3',
    cate: '기존교육원현장방문',
    title: '전화상담',
    actDt: '2020-11-01',
    regDt: '2020-11-01 10:00:00',
  },
];
export const boardData = [
  {
    key: '1',
    cate: '공지사항',
    title: '2013년 지역모임 자료',
    regDt: '2020-11-01 10:00:00',
  },
  {
    key: '2',
    cate: '공지사항',
    title: '2013년 지역모임 자료',
    regDt: '2020-11-01 10:00:00',
  },
  {
    key: '3',
    cate: '공지사항',
    title: '2013년 지역모임 자료',
    regDt: '2020-11-01 10:00:00',
  },
];
